import { useState, useRef, useEffect, useMemo } from 'react';
import styles from '@/components/Home/RenderButton/renderButton.module.scss';
import { LuCirclePower } from 'react-icons/lu';
import type { IconBaseProps } from 'react-icons';
import { ReactComponent as LoadingRing } from '@/components/Home/assets/loading-ring.svg';
import { useDaemonContext } from "@/providers/DaemonProvider";
import { startSilentPass, stopSilentPass } from "@/api";
import {Bridge} from '@/bridge/webview-bridge';
import { isPassportValid } from "@/utils/utils";
import { CoNET_Data } from '@/utils/globals';
import { getAllRegions } from "@/services/regions";
import BlobWrapper from '@/components/Home/BlobWrapper';
import { testNode, exitNodes} from '../../../services/mining'
import { startVPN, stopVPN, getAndroidVPNStatus } from "../../../api"

const PowerIcon = LuCirclePower  as React.ComponentType<IconBaseProps>;


const GENERIC_ERROR = 'Error Starting Silent Pass. Please try using our iOS App or our desktop Proxy program.';
const PASSPORT_EXPIRED_ERROR = 'Passport has expired. Please renew your passport and try again.';
const WAIT_PASSPORT_LOAD_ERROR = 'Passport info is loading. Please wait a few seconds and try again.';


const RenderButton = ({}) => {
    const [isConnectionLoading, setIsConnectionLoading] = useState<boolean>(false);
    const [showConnected, setShowConnected] = useState(false);
    const { power, setPower, isLocalProxy, switchValue, isIOS, profiles, getAllNodes, sRegion, setSRegion, setAllRegions, allRegions, closestRegion, setStatusVisible, privacyMode } = useDaemonContext();
    const [errorMessage, setErrorMessage] = useState<string>('');

    useEffect(() => {
        if (power && !isConnectionLoading) {
            setShowConnected(true);
            return ;
        }
        setShowConnected(false);
    }, [power, isConnectionLoading]);
	const status = async () => {


		const android = await getAndroidVPNStatus()
		if (android) {
			setPower(true)
		}
	}

	useEffect(()=>{
		// 监听 Electron 或 Native 的回传
		status()

	},[])
    const handleTogglePower = async () => {
        let error = false;
        setErrorMessage('');
        let selectedCountryIndex = -1
        setIsConnectionLoading(true);
        if (power) {
            if (isLocalProxy) {
                //          Desktop
                const response = await stopSilentPass();
                if (switchValue) {
                    Bridge.send('stopVPN',{},(res:any)=>{});
                }
            } else if (isIOS ) {
                window?.webkit?.messageHandlers["stopVPN"].postMessage(null)
				await stopVPN()
                //  @ts-ignore
            } else if (window.AndroidBridge && AndroidBridge.receiveMessageFromJS) {
                const base = btoa(JSON.stringify({cmd: 'stopVPN', data: ""}))
                //  @ts-ignore
                AndroidBridge.receiveMessageFromJS(base)
            }
            
            setTimeout(() => {setIsConnectionLoading(false);setPower(false);}, 2000)
            return ;
        }

		if (!profiles?.[0]?.activePassport?.expires) {
            setTimeout(() => {
                setIsConnectionLoading(false)
                setErrorMessage(WAIT_PASSPORT_LOAD_ERROR);
                setStatusVisible(true);
            }, 1000)
            return
        }

        if (!isPassportValid(profiles?.[0]?.activePassport?.expires)) {
            setTimeout(() => {
                setIsConnectionLoading(false)
                setErrorMessage(PASSPORT_EXPIRED_ERROR);
                setStatusVisible(true);
            }, 1000)
            return
        }

        const conetProfile = CoNET_Data?.profiles[0];
        const privateKey = conetProfile?.privateKeyArmor

        if (!privateKey) {
            return
        }

        // await getAllRegions()


        if (sRegion === -1) {
            selectedCountryIndex = Math.floor(Math.random() * allRegions.length)
            setSRegion(selectedCountryIndex);
        } else {
            selectedCountryIndex = sRegion
        }

        
        const exitRegion = allRegions[selectedCountryIndex].code
		let waiting = 0
		let _entryNodes = closestRegion

		// })

        const entryNodes = _entryNodes.map(n => {
            return {
                country: '',
                ip_addr: n.ip_addr,
                region: n.region,
                armoredPublicKey: n.armoredPublicKey,
                nftNumber: n.nftNumber.toString()
            }
        })



		
		const _exitNodes = exitNodes(exitRegion, _entryNodes)

        let _exitNode = []
		do {
			const randomExitIndex = Math.floor(Math.random() * (_exitNodes.length))
			const node = _exitNodes[randomExitIndex]
			const isWorking = await testNode(node)
			if (isWorking) {
				_exitNode.push(node)
			}

		} while(_exitNode.length == 0)
		

        const exitNode = _exitNode.map(n => {
            return {
                country: '',
                ip_addr: n.ip_addr,
                region: n.region,
                armoredPublicKey: n.armoredPublicKey,
                nftNumber: n.nftNumber.toString()
            }
        })

        const startVPNMessageObject: Native_StartVPNObj = {
            entryNodes,
            exitNode,
            privateKey
        }
        const stringifiedVPNMessageObject = JSON.stringify(startVPNMessageObject)
        const base64VPNMessage = btoa(stringifiedVPNMessageObject)


        if (isLocalProxy) {
            await startSilentPass(startVPNMessageObject);
            if (switchValue) {
                Bridge.send('startVPN',{data:base64VPNMessage},(res:any)=>{});
            }   
        } else {
            if (isIOS) {
                window?.webkit?.messageHandlers["startVPN"].postMessage(base64VPNMessage)
				await startVPN(startVPNMessageObject)
                //  @ts-ignore
            } else if (window?.AndroidBridge && AndroidBridge?.receiveMessageFromJS) {
                const base = btoa(JSON.stringify({cmd: 'startVPN', data: base64VPNMessage}))
                //  @ts-ignore
                AndroidBridge.receiveMessageFromJS(base)
            }
        }
        setTimeout(() => {
            setIsConnectionLoading(false)
            setPower(true)
        }, 1000)

        return ;
    };
    const state = useMemo(
        () => (isConnectionLoading ? 'connecting' : power ? 'on' : 'off'),
        [isConnectionLoading, power]
    );

    return (
        <div className={styles.renderButton}>
            <BlobWrapper state={state}>
                <div
                    className={power ? `${styles.power} ${styles.powerOn}` : `${styles.power} ${styles.powerOff}`}
                    onClick={!isConnectionLoading ? handleTogglePower : undefined}
                >
                    {isConnectionLoading ? (
                        <LoadingRing className={ `${styles.powerIcon} ${styles.loadingSpinning}`} />
                    ) : (
                        power ?<PowerIcon className={ `${styles.powerIcon} ${styles.powerIconOn}`} /> :<PowerIcon className={ `${styles.powerIcon} ${styles.powerIconOff}`} />
                    )}
                </div>
            </BlobWrapper>
            {isConnectionLoading && <div className={styles.loadingText}>{power?'Disconnecting...':'Loading...'}</div>}
            {showConnected && <div className={styles.connected}>Connected</div>}
        </div>
    );
};

export default RenderButton;